import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function LoadFreespinCommand(): Contract<void> {
    const payload = new FreespinRequestPayload();

    return CommsManager.request(payload);
}
